import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { initIfConsented, trackPageView } from "@/lib/analytics";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CookieConsent } from "./components/CookieConsent";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import BusinessOutreachPrivacy from "./pages/BusinessOutreachPrivacy";
import Terms from "./pages/Terms";
import SubProcessors from "./pages/SubProcessors";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ApiTest from "./pages/ApiTest";
import Start from "./pages/Start";
import SeoCheck from "./pages/SeoCheck";

initIfConsented();

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  // Handle subscription/unsubscribe redirects from email links
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.get("subscribed") === "true") {
      toast.success("You're subscribed! Thanks for signing up.");
      window.history.replaceState({}, "", pathname);
    } else if (params.get("unsubscribed") === "true") {
      toast.success("You've been unsubscribed successfully.");
      window.history.replaceState({}, "", pathname);
    }
  }, [search, pathname]);

  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/business-outreach-privacy" element={<BusinessOutreachPrivacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/sub-processors" element={<SubProcessors />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/api-test" element={<ApiTest />} />
            <Route path="/start" element={<Start />} />
            <Route path="/seo-check" element={<SeoCheck />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
